import { render, staticRenderFns } from "./ReorganizeAfterDelete.vue?vue&type=template&id=d404957e&"
import script from "./ReorganizeAfterDelete.vue?vue&type=script&lang=js&"
export * from "./ReorganizeAfterDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports